import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useRealtimeEvent } from '@/lib/realtime';
import { appendMessage, chatKeys, setMessageStatus } from './api';

/**
 * App-wide listener (mounted in the shell) that keeps chat caches fresh, so the sidebar
 * badge and inbox lists update even when the Chats page isn't open.
 */
export function ChatsRealtimeSync() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useRealtimeEvent('conversation:updated', (e) => {
    void qc.invalidateQueries({ queryKey: ['conversations', 'list'] });
    void qc.invalidateQueries({ queryKey: chatKeys.queuedCount });
    void qc.invalidateQueries({ queryKey: chatKeys.detail(e.conversationId) });
    if (e.status === 'QUEUED' && !pathname.startsWith('/chats')) {
      toast.info('A citizen is waiting for an agent', {
        id: `queued-${e.conversationId}`,
        action: { label: 'Open', onClick: () => void navigate(`/chats/${e.conversationId}`) },
      });
    }
  });

  // Only arrives for conversations this tab has joined (the open thread).
  useRealtimeEvent('message:new', (e) => {
    appendMessage(qc, e.conversationId, e.message);
    void qc.invalidateQueries({ queryKey: ['conversations', 'list'] });
  });

  useRealtimeEvent('message:status', (e) =>
    setMessageStatus(qc, e.conversationId, e.messageId, e.status),
  );

  return null;
}
